import type { TFunction } from 'i18next'

/**
 * Translate a stored enum value (role, subscription status, tier, feature key, ...).
 * Firestore keeps the canonical English value; unknown values written by a newer
 * app version degrade to the raw string instead of showing a missing key.
 */
export function enumLabel(t: TFunction, prefix: string, value: string): string {
  return t(`${prefix}.${value.toLowerCase()}`, { defaultValue: value })
}
